/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockSupplierEditCtrl
 */
angular.module('mercury.modules.stock.supplier')
.controller('StockSupplierEditCtrl', ["dialog", "$scope", "supplierId", "StockSuppliers", function(dialog, $scope, supplierId, StockSuppliers) {
  $scope.activeTab = 'details';

  $scope.supplier = StockSuppliers.get(supplierId);
  $scope.aliases = StockSuppliers.getAliases(supplierId);
  $scope.aliasIdsToDelete = [];

  $scope.supplier.$promise.then(function() {
    $scope.supplier.orderDirectCredentialsObj = null;
    if ($scope.supplier.orderDirectCredentials !== null) {
      $scope.supplier.orderDirectCredentialsObj = JSON.parse($scope.supplier.orderDirectCredentials);
    }
  });

  /**
  * Save changes made to an existing supplier
  */
  $scope.save = function() {
    if ($scope.supplierEditForm.$invalid) {
      $scope.activeTab = 'details';
      return;
    }

    if ($scope.supplier.orderDirectCredentialsObj !== null) {
      $scope.supplier.orderDirectCredentials = JSON.stringify($scope.supplier.orderDirectCredentialsObj);
    }

    savingActions = [StockSuppliers.update($scope.supplier)];

    $scope.aliasIdsToDelete.forEach(function (aliasId) {
      savingActions.push(StockSuppliers.deleteAlias(supplierId, aliasId));
    });

    $scope.savingSupplier = Promise.all(savingActions);

    $scope.savingSupplier.then(function() {
      $scope.$close($scope.supplier);
    });
  };

  $scope.deleteAlias = function(index) {
    $scope.aliasIdsToDelete.push($scope.aliases[index].id);
    $scope.aliases.splice(index, 1);
  }

  /**
  * State options for ordering from Allied Liquor.
  */
  $scope.alliedLiquorStates = {
    '1': 'New South Wales',
    '2': 'Victoria',
    '3': 'Queensland',
    '4': 'Western Australia',
    '5': 'South Australia',
    '6': 'Northern Territory',
    '7': 'Tasmania',
    '8': 'Australia Capital Territory',
    '9': 'New Zealand'
  };

  /**
  * Callback for when order direct activation is changed. If there are no credentials already saved, specify the defaults.
  */
  $scope.orderDirectChange = function() {
    if ($scope.supplier.orderDirect && $scope.supplier.orderDirectCredentialsObj === null) {
      $scope.supplier.orderDirectCredentialsObj = {
        state: '9'
      };
    }
  };
}]);
